import { Button, Col, Form, InputNumber, Row, Select } from "antd";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addLeaveApplication, getSingleLeaveAllocation, loadSingleLeaveHistory } from "../../redux/rtk/features/leave/leaveSlice";
// import { loadAllLeaveType } from "../../redux/rtk/features/leavePolicy/leavePolicySlice";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { loadAllPublicHoliday } from "../../redux/rtk/features/publicHoliday/publicHolidaySlice";
import { loadAllShift } from "../../redux/rtk/features/shift/shiftSlice";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import { loadAllWeeklyHoliday } from "../../redux/rtk/features/weeklyHoliday/weeklyHolidaySlice";
import getPermissions from "../../utils/getPermissions";
import getUserFromToken from "../../utils/getUserFromToken";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import PublicHolidayDatePicker from "./publicHoliday";
dayjs.extend(isSameOrBefore);

dayjs.extend(utc);
dayjs.extend(timezone);

const AddLeave = ({ drawer, onUserChange }) => {
  const [loader, setLoader] = useState(false);
  const shift = useSelector((state) => state?.shift?.list);
  // const { list, loading } = useSelector((state) => state.leavePolicy);
  const [endDate, setEndDate] = useState(null);
  const [totalDays, setTotalDays] = useState(1);
  // const userId = getUserFromToken();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const userId = getUserFromToken();
  const permissions = getPermissions();
  // console.log("pp", permissions)
  const hasPermission = (item) => {
    return permissions?.includes(item ? item : "");
  };

  const list = useSelector((state) => state?.leave?.leave) || [];
  console.log('list>>', list);
  const loading = useSelector((state) => state.loading || []);
  console.log('loading>>', loading);
  const staffList = useSelector((state) => state?.users?.list);
  const weeklyHoliday = useSelector((state) => state?.weeklyHoliday?.list || []);
  const publicHolidayData = useSelector((state) => state?.publicHoliday?.list || []);
  const leaveHistoryData = useSelector((state) => state?.leaveHistory || []);

  const publicHolidays = Array.isArray(publicHolidayData) ? publicHolidayData : [];
  console.log("publicHolidays", publicHolidays);
  console.log("weeklyHoliday", weeklyHoliday);

  const leaveHistory = Array.isArray(leaveHistoryData) ? leaveHistoryData : [];
  useEffect(() => {
    const loadData = async () => {
      try {
        await Promise.all([
          dispatch(loadAllPublicHoliday()),
          dispatch(loadAllWeeklyHoliday()),
          dispatch(loadSingleLeaveHistory(userId))
        ]);
      } catch (error) {
        console.error('Error loading calendar data:', error);
      }
    };
    loadData();
  }, [dispatch, userId]);

  useEffect(() => {
    dispatch(loadAllStaff({ status: true }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(loadAllShift());
    dispatch(getSingleLeaveAllocation(userId));
  }, [dispatch, userId]);

  // useEffect(() => {
  //   dispatch(loadAllShift());
  //   // dispatch(loadAllLeaveType());
  // }, [dispatch]);

  const calculateEndDate = (startDate, days) => {
    if (startDate && days) {
      let newEndDate;
      if (days <= 1.00) {
        newEndDate = startDate;
      } else {
        newEndDate = dayjs(startDate).add(days - 1, 'day');
      }
      setEndDate(newEndDate);
      form.setFieldsValue({ leaveTo: newEndDate });
    }
  };

  const handleTotalDaysChange = (value) => {
    setTotalDays(value);
    const startDate = form.getFieldValue('leaveFrom');
    calculateEndDate(startDate, value);
  };

  // const handleStartDateChange = (date) => {
  //   calculateEndDate(date, totalDays);
  // };


  const formatDate = (date) => {
    return dayjs(date)
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0)
      .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
  };

  const handleUserSelection = (userId) => {
    if (onUserChange) {
      onUserChange(userId);
    }
  };

  const calculateLeaveDays = (startDate, endDate, weeklyOffs, publicHolidays) => {
    if (!startDate || !endDate) return 0;

    let totalDays = 0;
    let currentDate = dayjs(startDate);
    const publicHolidayDates = new Set(
      publicHolidays.map((holiday) => dayjs(holiday.date).format("YYYY-MM-DD"))
    );

    while (currentDate.isSameOrBefore(endDate, 'day')) {
      const isWeekend =
        currentDate.day() === 0 || currentDate.day() === 6; // 0 = Sunday, 6 = Saturday
      const isWeeklyOff = isWeekend || weeklyOffs.includes(currentDate.format('YYYY-MM-DD'));
      // const isPublicHoliday = publicHolidays.some(
      //   (holiday) => holiday.date === currentDate.format('YYYY-MM-DD')
      // );
      const currentDateString = currentDate.format("YYYY-MM-DD");
      const isPublicHoliday = publicHolidayDates.has(currentDateString);
      console.log("isPublicHoliday", isPublicHoliday);

      if (!isWeeklyOff && !isPublicHoliday) {
        totalDays++;
      }

      currentDate = currentDate.add(1, 'day');
    }

    return totalDays;
  };



  const handleStartDateChange = (date) => {
    const endDate = form.getFieldValue('leaveTo');
    const leaveDays = calculateLeaveDays(date, endDate, [], publicHolidays);
    setTotalDays(leaveDays);
    form.setFieldsValue({ totalleaveDays: leaveDays });
    setEndDate(endDate);
  };

  const handleEndDateChange = (date) => {
    const startDate = form.getFieldValue('leaveFrom');
    const leaveDays = calculateLeaveDays(startDate, date, [], publicHolidays);
    setTotalDays(leaveDays);
    form.setFieldsValue({ totalleaveDays: leaveDays });
    setEndDate(date);
  };



  const onFinish = async (values) => {
    try {
      setLoader(true);
      const leaveData = {
        ...values,
        userId: hasPermission("update-role") ? values.userId : userId,
        leaveFrom: formatDate(values.leaveFrom),
        leaveTo: formatDate(values.leaveTo),
        totalleaveDays: values.totalleaveDays
      };

      const resp = await dispatch(addLeaveApplication(leaveData));

      if (resp.payload.message === "success") {
        // toast.success("Leave application submitted successfully");
        form.resetFields();
        setEndDate(null);
        setTotalDays(1);
        dispatch(loadAllShift());
      } else {
        // toast.error("Failed to submit leave application");
      }
    } catch (error) {
      toast.error("An error occurred while submitting leave application");
    } finally {
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    toast.warning("Please fill all required fields");
  };

  return (
    <Fragment>
      <UserPrivateComponent permission={"create-leaveApplication"}>
        <Row className='mr-top' justify={drawer ? "center" : "center"}>
          <Col className=''>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name='leave-form'
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 14 }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
            >

              {hasPermission("update-role") && (
                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label='Employee'
                  name='userId'
                  rules={[
                    {
                      required: true,
                      message: "Please select an employee!",
                    },
                  ]}>
                  <Select placeholder='Select Employee'
                    showSearch
                    allowClear
                    onChange={handleUserSelection}
                    filterOption={(input, option) =>
                      String(option.children).toLowerCase().includes(input.toLowerCase())
                    }>
                    {staffList?.slice() // Create a copy to avoid mutating the original array
											.sort((a, b) => a.firstName.localeCompare(b.firstName)).map((staff) => (
                      <Select.Option key={staff.id} value={staff.id}>
                        {staff.firstName} {staff.lastName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
              <Form.Item
                style={{ marginBottom: "10px" }}
                label="Leave Type"
                name="leavePolicyId"
                rules={[{ required: true, message: "Please select a leave type!" }]}
              >
                <Select
                  mode="single"
                  placeholder="Select leave type"
                  showSearch allowClear
                  filterOption={(input, option) =>
                    String(option.children).toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {list.length > 0 ? (
                    list.map((leave) => (
                      <Select.Option key={leave?.leavePolicy?.id} value={leave?.leavePolicy?.id}>
                        {leave?.leavePolicy?.name}
                      </Select.Option>
                    ))
                  ) : (
                    <Select.Option disabled>No leave types available</Select.Option>
                  )}
                </Select>
              </Form.Item>


              {/* <Form.Item
                style={{ marginBottom: "10px" }}
                label='Start Date'
                name='leaveFrom'
                rules={[{ required: true, message: "Please select start date!" }]}
              >
                <DatePicker
                  onChange={handleStartDateChange}
                  format="YYYY-MM-DD"
                  showTime={false}
                />
              </Form.Item> */}
              <Form.Item
                style={{ marginBottom: "10px" }}
                label='Start Date'
                name='leaveFrom'
                rules={[{ required: true, message: "Please select start date!" }]}
              >
                <PublicHolidayDatePicker
                  publicHolidays={publicHolidays}
                  onChange={(date, holiday) => {
                    handleStartDateChange(date);
                    if (holiday) {
                      console.log(`Selected date is a holiday: ${holiday.name}`);
                    }
                  }}
                  format="YYYY-MM-DD"
                  showTime={false}
                  showToday={false}
                />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "20px" }}
                label="End Date"
                name="leaveTo"
                rules={[{ required: true, message: "Please select End date!" }]}

              >

                <PublicHolidayDatePicker
                  publicHolidays={publicHolidays}

                  value={endDate}
                  onChange={handleEndDateChange}
                  format="YYYY-MM-DD"
                  showTime={false}
                  showToday={false}
                />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                label='Total Days'
                name='totalleaveDays'
                rules={[{ required: true, message: "Please enter the total days!" }]}
              >
                <InputNumber
                  min={0.25}
                  step={0.25}
                  onChange={handleTotalDaysChange}
                />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                wrapperCol={{ offset: 6, span: 12 }}
              >
                <Button
                  type='primary'
                  size='large'
                  htmlType='submit'
                  block
                  loading={loader}
                  disabled={loader}
                >
                  {loader ? 'Submitting...' : 'Submit Leave'}
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </UserPrivateComponent>
    </Fragment>
  );
};

export default AddLeave;